import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const estimateRoutes: Routes = [];
@NgModule({
  imports: [RouterModule.forChild(estimateRoutes)],
  exports: [RouterModule]
})
export class EstimateRoutingModule {}
